import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';
import merge from 'lodash/merge';

import {Box, Grid, GridItem, MenuList} from '@spothero/ui';

import {useAnimationContext} from 'common/animation/AnimationContext';
import {selectSelectedFacility} from 'pages/facilities/store/facilities-selectors';

import FacilityInformationDisplay from './FacilityInformationDisplay';
import NavigationMenuGroup from './NavigationMenuGroup';

const getMenuListStyleProps = ({collapsed, isMultiSelect}) => ({
    display: 'flex',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    gap: 4,
    height: isMultiSelect ? '27rem' : '30rem',
    paddingLeft: collapsed ? 'calc(4.375rem + 2rem)' : 'calc(21.875rem + 2rem)',
});

const getGridRows = (menuContentArray) =>
    menuContentArray.length > 3 ? 'repeat(2, 1fr)' : 'repeat(1, 1fr)';

const NavigationDropDownMenu = ({isMultiSelect, menuContentArray}) => {
    const {title, address, physicalAddress} = useSelector(
        selectSelectedFacility
    );

    // TODO: We need to normalize the address/physicalAdress object to have the same keys
    const {streetAddress, city, state, zipcode} = merge(
        {},
        {
            city: physicalAddress?.city,
            state: physicalAddress?.state,
            streetAddress:
                physicalAddress?.streetAddress || physicalAddress?.street,
            zipcode: physicalAddress?.zipcode || physicalAddress?.zip,
        },
        {
            city: address?.city,
            state: address?.state,
            streetAddress: address?.street || address?.streetAddress,
            zipcode: address?.zip || address?.zipcode,
        }
    );
    const addressString = `${streetAddress && streetAddress} ${
        city && city
    }, ${state && state} ${zipcode && zipcode}`;
    const {
        collapsed: [collapsed],
    } = useAnimationContext();

    return (
        <MenuList {...getMenuListStyleProps({collapsed, isMultiSelect})}>
            <Box margin="0 auto" width="full" maxWidth="90rem" height="100%">
                {!isMultiSelect && (
                    <FacilityInformationDisplay
                        title={title}
                        address={addressString}
                    />
                )}
                <Grid
                    isCompact
                    templateRows={getGridRows(menuContentArray)}
                    width="100%"
                >
                    {menuContentArray.map(({heading, submenu}, index) => {
                        const shouldSpanMultipleRows =
                            index < menuContentArray.length - 2;

                        return (
                            <Fragment key={index}>
                                <GridItem
                                    key={index}
                                    colSpan={4}
                                    colStart={index + 3 / 12}
                                    {...(shouldSpanMultipleRows && {
                                        rowSpan: 2,
                                    })}
                                    {...(shouldSpanMultipleRows && {
                                        paddingRight: 3,
                                        borderRight: '1px solid',
                                        borderColor: 'gray.medium',
                                    })}
                                >
                                    <NavigationMenuGroup
                                        heading={heading}
                                        submenu={submenu}
                                    />
                                </GridItem>
                            </Fragment>
                        );
                    })}
                </Grid>
            </Box>
        </MenuList>
    );
};

NavigationDropDownMenu.propTypes = {
    isMultiSelect: PropTypes.bool.isRequired,
    menuContentArray: PropTypes.arrayOf(
        PropTypes.shape({
            heading: PropTypes.string.isRequired,
            submenu: PropTypes.arrayOf(
                PropTypes.shape({
                    label: PropTypes.string.isRequired,
                    subtitle: PropTypes.string,
                    route: PropTypes.string.isRequired,
                    isDisabled: PropTypes.bool,
                    isNew: PropTypes.bool,
                })
            ),
        })
    ).isRequired,
};

export default NavigationDropDownMenu;
